import ApiRequestManagerInstance from '../ApiRequestManager';
import { IChannelOrder } from '../../types/interfaces/channel';

function putChannelsOrder(channels: IChannelOrder[]) {
  const promise = new Promise<boolean>(async (resolve) => {
    try {
      await ApiRequestManagerInstance.put({
        endpoint: { url: 'apiUrl', section: 'user', subsection: 'channels' },
        data: { channels },
      });
      resolve(true);
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });

  return promise;
}

export default putChannelsOrder;
